<template>
  <div id="ranking-board">
    <div class="ranking-board-title">模具上报记录数量</div>
    <dv-scroll-ranking-board :config="config" />
  </div>
</template>

<script>
export default {
  name: 'RankingBoard',
  data () {
    return {
      config: {
        data: [
          {
            name: '在产模具',
            value: 55
          },
          {
            name: '修模记录',
            value: 120
          },
          {
            name: '试模中',
            value: 78
          },
          {
            name: '生产模具',
            value: 66
          },
          {
            name: '完成模具',
            value: 80
          },
          {
            name: '测试1',
            value: 45
          },
          {
            name: '测试2',
            value: 129
          },
          {
            name: '测试3',
            value: 209
          },
          {
            name: '测试6',
            value: 28
          },
          {
            name: '测试12',
            value: 22
          },
          {
            name: '测试6',
            value: 208
          },
          {
            name: '测试12',
            value: 192
          },
          {
            name: '测试6',
            value: 98
          },
          {
            name: '测试12',
            value: 88
          },
          {
            name: '测试6',
            value: 99
          },
          {
            name: '测试12',
            value: 19
          }
        ],
        rowNum: 16
      }
    }
  }
}
</script>

<style lang="less">
#ranking-board {
  width: 20%;
  box-shadow: 0 0 3px blue;
  display: flex;
  flex-direction: column;
  background-color: rgba(6, 30, 93, 0.5);
  border-top: 2px solid rgba(1, 153, 209, .5);
  box-sizing: border-box;
  padding: 0px 30px;

  .ranking-board-title {
    font-weight: bold;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 20px;
  }

  .dv-scroll-ranking-board {
    flex: 1;
  }
}
</style>
